document.addEventListener('DOMContentLoaded', function() {
    // Funktion zum Anpassen der Höhe der variant-image-tile__label Elemente
    function adjustVariantTileLabelsHeight() {
        // Alle label-Elemente auswählen
        const labelElements = document.querySelectorAll('.variant-image-tile__label');
        
        if (labelElements.length === 0) return;
        
        // Höhe zurücksetzen, um korrekte Messung zu ermöglichen
        labelElements.forEach(label => {
            label.style.height = 'auto';
        });
        
        // Maximale Höhe ermitteln
        let maxHeight = 0;
        labelElements.forEach(label => {
            const height = label.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        
        // Höhe für alle Elemente setzen
        if (maxHeight > 0) {
            labelElements.forEach(label => {
                label.style.height = maxHeight + 'px';
            });
            console.log('Variant tile labels height adjusted to:', maxHeight, 'px');
        }
    }
    
    // Funktion beim Laden der Seite ausführen
    adjustVariantTileLabelsHeight();
    
    // Funktion auch beim Resize des Fensters ausführen
    window.addEventListener('resize', adjustVariantTileLabelsHeight);
    
    // Funktion auch ausführen, wenn Bilder geladen sind (falls Bilder die Höhe beeinflussen)
    window.addEventListener('load', adjustVariantTileLabelsHeight);
    
    // Funktion zum Aktualisieren der Varianten-ID im Formular und ATC-Button direkt aus der URL
    function updateVariantIdFromURL() {
        // Hole die Varianten-ID aus der URL
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        
        if (variantId) {
            console.log('Varianten-ID aus URL:', variantId);
            
            // Aktualisiere das Formular
            const productForm = document.querySelector('.custom-product-form');
            if (productForm) {
                productForm.setAttribute('data-current-product-id', variantId);
            }
            
            // Aktualisiere den ATC-Button
            const atcButton = document.querySelector('[data-variant-atc-id]');
            if (atcButton) {
                atcButton.setAttribute('data-variant-atc-id', variantId);
            }
            
            // Aktualisiere auch das versteckte Select-Element
            const variantSelector = document.getElementById('variant-selector');
            if (variantSelector) {
                variantSelector.value = variantId;
            }
            
            return true;
        }
        return false;
    }
    
    // Wenn keine Varianten-ID in der URL ist, verwende die vorausgewählte Variante
    function updateVariantIdFromSelector() {
        const variantSelector = document.getElementById('variant-selector');
        if (variantSelector && variantSelector.value) {
            const selectedVariantId = variantSelector.value;
            
            // Aktualisiere das Formular
            const productForm = document.querySelector('.custom-product-form');
            if (productForm) {
                productForm.setAttribute('data-current-product-id', selectedVariantId);
            }
            
            // Aktualisiere den ATC-Button
            const atcButton = document.querySelector('[data-variant-atc-id]');
            if (atcButton) {
                atcButton.setAttribute('data-variant-atc-id', selectedVariantId);
            }
            
            console.log('Varianten-ID aus Selektor:', selectedVariantId);
        }
    }
    
    // Initialisiere die Varianten-ID beim Laden der Seite
    // Versuche zuerst aus der URL, dann aus dem Selektor
    if (!updateVariantIdFromURL()) {
        updateVariantIdFromSelector();
    }
    
    // Variant Images Grid Functionality
    const variantImageTiles = document.querySelectorAll('.variant-image-tile');
    
    variantImageTiles.forEach(tile => {
        tile.addEventListener('click', function() {
            // Get the value and option position from the button
            const value = this.getAttribute('title');
            const optionPosition = this.closest('[data-product-option]').getAttribute('data-product-option').replace('Option', '');
            
            // Find the corresponding select element
            const selectElement = document.getElementById('option' + optionPosition);
            
            if (selectElement) {
                // Set the value in the select element
                selectElement.value = value;
                
                // Trigger the change event to update the variant
                const changeEvent = new Event('change', { bubbles: true });
                selectElement.dispatchEvent(changeEvent);
                
                // Update visual selection
                const allTiles = this.closest('.variant-images-grid').querySelectorAll('.variant-image-tile');
                allTiles.forEach(t => t.classList.remove('selected'));
                this.classList.add('selected');
            }
        });
    });
    
    // Dropdown Variant Buttons Functionality
    const swatchButtons = document.querySelectorAll('[data-swatch-button="true"]');
    
    swatchButtons.forEach(button => {
        button.addEventListener('click', function() {
            // Get the value and option position from the button
            const value = this.getAttribute('data-label');
            const optionPosition = this.closest('[data-product-option]').getAttribute('data-product-option').replace('Option', '');
            
            // Find the corresponding select element
            const selectElement = document.getElementById('option' + optionPosition);
            
            if (selectElement) {
                // Set the value in the select element
                selectElement.value = value;
                
                // Trigger the change event to update the variant
                const changeEvent = new Event('change', { bubbles: true });
                selectElement.dispatchEvent(changeEvent);
                
                // Update visual selection
                const allButtons = this.closest('.product__color-swatches').querySelectorAll('[data-swatch-button="true"]');
                allButtons.forEach(b => b.classList.remove('selected'));
                this.classList.add('selected');
                
                // Update the displayed value
                const swatchValueElement = this.closest('.option-dropdown__title').querySelector('[data-swatch-selected]');
                if (swatchValueElement) {
                    swatchValueElement.textContent = value;
                }
            }
        });
    });
    
    // Event-Listener für Änderungen an den Select-Elementen
    // Dies wird ausgelöst, wenn eine Variante durch Klick auf einen Button geändert wird
    const optionSelects = document.querySelectorAll('select[id^="option"]');
    optionSelects.forEach(select => {
        select.addEventListener('change', function() {
            // Warte kurz, bis die Variante aktualisiert wurde
            setTimeout(() => {
                updateVariantIdFromURL() || updateVariantIdFromSelector();
            }, 100);
        });
    });
    
    // Product Listing Variant Functionality
    const productElements = document.querySelectorAll('[data-product-id]');
    
    productElements.forEach(productElement => {
        const variantItems = productElement.querySelectorAll('.product-item-options__item--swatch');
        const variantImages = productElement.querySelectorAll('.ds-product-item__image--two');

        function resetImages() {
            variantImages.forEach(img => {
                img.style.opacity = '0';
                img.classList.remove('active');
            });
            variantItems.forEach(item => {
                item.classList.remove('ds-active');
            });
        }

        resetImages();

        // Set first variant item as active
        if (variantItems.length > 0) {
            variantItems[0].classList.add('ds-active');
        }

        variantItems.forEach(item => {
            const variantId = item.dataset.variant;
            if (!variantId) return;

            item.addEventListener('click', (event) => {
                event.preventDefault();
                resetImages();
                
                // Update product ID with variant ID
                productElement.dataset.productId = variantId;
                
                // Update image
                const matchingImage = productElement.querySelector(`.ds-product-item__image--two img[data-variant="${variantId}"]`);
                const matchingWrapper = matchingImage ? matchingImage.closest('.ds-product-item__image--two') : null;
                
                // Hide default product image
                const defaultImage = productElement.querySelector('.product-item__image--one img');
                if (defaultImage) {
                    defaultImage.style.opacity = '0';
                }

                if (matchingWrapper) {
                    matchingWrapper.style.opacity = '1';
                    matchingWrapper.classList.add('active');
                    item.classList.add('ds-active');
                }

                // Update all product links to include the variant ID
                const productLinks = productElement.querySelectorAll('a[href*="/products/"]');
                productLinks.forEach(link => {
                    const url = new URL(link.href);
                    url.searchParams.set('variant', variantId);
                    link.href = url.toString();
                });

                // Update the add to cart form
                const form = productElement.querySelector('.product-form');
                if (form) {
                    // Update hidden input value
                    const variantInput = form.querySelector('input[name="id"]');
                    if (variantInput) variantInput.value = variantId;

                    // Update form data attribute
                    form.dataset.currentProductId = variantId;

                    // Update ATC button data attribute
                    const atcButton = form.querySelector('.ds-custom-atc-button');
                    if (atcButton) atcButton.dataset.variantAtcId = variantId;
                }

                // Update prices
                const variantPrices = productElement.querySelector('[data-variant-prices]');
                if (variantPrices) {
                    const variantPrice = variantPrices.querySelector(`[data-variant-id="${variantId}"]`);
                    if (variantPrice) {
                        const price = parseInt(variantPrice.dataset.price, 10) / 100; // Convert cents to euros
                        const comparePrice = variantPrice.dataset.comparePrice ? parseInt(variantPrice.dataset.comparePrice, 10) / 100 : 0;
                        const priceElement = variantPrices.querySelector('[data-price-element]');
                        const comparePriceElement = variantPrices.querySelector('[data-compare-price-element]');

                        if (priceElement) {
                            // Format price with currency
                            const formattedPrice = new Intl.NumberFormat('de-DE', {
                                style: 'currency',
                                currency: 'EUR',
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }).format(price).replace(/\s/g, '');

                            priceElement.textContent = formattedPrice;
                            
                            // Update price element class based on whether it's on sale
                            priceElement.className = comparePrice > price ? 'sale ds-colored-price' : 'product-item__price';
                        }

                        if (comparePriceElement) {
                            if (comparePrice > price) {
                                const formattedComparePrice = new Intl.NumberFormat('de-DE', {
                                    style: 'currency',
                                    currency: 'EUR',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }).format(comparePrice).replace(/\s/g, '');
                                
                                comparePriceElement.textContent = formattedComparePrice;
                                comparePriceElement.style.display = '';
                            } else {
                                comparePriceElement.style.display = 'none';
                            }
                        }
                    }
                }
            });
        });
    });
});